/**
 * This code was  originally copied from the lexical playground source code on github
 * And so it doesn't follow our code style
 * https://github.com/facebook/lexical/tree/main/packages/lexical-playground
 *
 */

import "./CommentEditorTheme.css";

import type { EditorThemeClasses } from "lexical";

import baseTheme from "../PlaygroundEditorTheme";

const theme: EditorThemeClasses = {
    ...baseTheme,
    paragraph: "CommentEditorTheme__paragraph",
};

export default theme;
